/** @file Marquee selection: indices of the world points whose screen projection lies in a rectangle. */
import type { Vec2 } from '@pose2d/math/types';
import type { Camera } from '@pose2d/geometry/types';
import { projectPoint } from './_internal/projectPoint';
import { normalizeRect } from './normalizeRect';
import type { ScreenRect } from './normalizeRect';
import type { PointSet } from './pickPoint';

/** Indices (ascending) of the points inside the screen rectangle, edges inclusive; corners in any order. */
export function pointsInRect(points: PointSet, camera: Camera, rect: ScreenRect): number[] {
  const r = normalizeRect(rect);
  const s: Vec2 = [0, 0];
  const out: number[] = [];
  for (let i = 0; i < points.count; i++) {
    projectPoint(points, i, camera, s);
    if (s[0] >= r.x0 && s[0] <= r.x1 && s[1] >= r.y0 && s[1] <= r.y1) out.push(i);
  }
  return out;
}
